// Alternative Products — renders DataGate `alternateItems` for the current
// product as a pc-card grid with Details + Add-to-Cart (no Quick View, by request). All the logic lives
// in shared/relatedProducts.js (shared with the Suggested Items widget).
//
// Mount (read from the TARGET element, not the script tag):
//   #parts-alternative-products  OR  [data-parts-alternative-products] — container
//   data-sku-selector="#product-sku"  (optional; overrides the SKU source)
//   data-limit="6"                     (optional; number to fetch)
//   data-title="Alternative products"  (optional; section heading)

import { createRelatedWidget } from '../shared/relatedProducts.js';

var widget = createRelatedWidget({
	id: 'alternative-products',
	containerId: 'parts-alternative-products',
	dataAttr: 'data-parts-alternative-products',
	endpointFor: function (sku, limit) {
		return '/api/parts/' + encodeURIComponent(sku) + '/alternatives?limit=' + limit;
	},
	responseKey: 'alternatives',
	defaultTitle: 'Alternative Parts',
	loadingText: 'Loading alternative parts...',
	emptyText: 'No alternative parts found for this part.',
	quickView: false,
});

export var init = widget.init;
export var id = widget.id;
